import { useCallback, useEffect, useState } from "react";
import { ScrollTrigger } from "@/animations/gsap";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";
import { useLenis } from "@/hooks/useLenis";
import { Preloader } from "@/components/Preloader/Preloader";
import { Navigation } from "@/components/Navigation/Navigation";
import { Cursor } from "@/components/Cursor/Cursor";
import { Hero } from "@/components/Hero/Hero";
import { About } from "@/components/About/About";
import { Expertise } from "@/components/Expertise/Expertise";
import { Philosophy } from "@/components/Philosophy/Philosophy";
import { Experience } from "@/components/Experience/Experience";
import { Projects } from "@/components/Projects/Projects";
import { EngineeringLab } from "@/components/EngineeringLab/EngineeringLab";
import { TechStack } from "@/components/TechStack/TechStack";
import { Leadership } from "@/components/Leadership/Leadership";
import { Contact } from "@/components/Contact/Contact";
import { Footer } from "@/components/Footer/Footer";
import { ErrorBoundary } from "@/components/ErrorBoundary";

export default function App() {
  const reduced = usePrefersReducedMotion();
  const [revealed, setRevealed] = useState(false);
  const [preloaderDone, setPreloaderDone] = useState(false);

  useLenis(revealed && !reduced);

  useEffect(() => {
    document.body.style.overflow = revealed ? "" : "hidden";
    if (!revealed) return undefined;
    const t = window.setTimeout(() => ScrollTrigger.refresh(), 150);
    return () => window.clearTimeout(t);
  }, [revealed]);

  useEffect(() => {
    if (reduced) {
      setRevealed(true);
      setPreloaderDone(true);
    }
  }, [reduced]);

  const handleReveal = useCallback(() => setRevealed(true), []);
  const handlePreloaderDone = useCallback(() => setPreloaderDone(true), []);

  return (
    <ErrorBoundary>
      <Cursor />
      {!preloaderDone && !reduced && <Preloader onReveal={handleReveal} onDone={handlePreloaderDone} />}
      <Navigation started={revealed} />
      <main id="main">
        <Hero started={revealed} />
        <About />
        <Expertise />
        <Philosophy />
        <Experience />
        <Projects />
        <EngineeringLab />
        <TechStack />
        <Leadership />
        <Contact />
      </main>
      <Footer />
      <div className="grain" aria-hidden="true" />
    </ErrorBoundary>
  );
}
